import { IRBDItem } from '../../../../models/rbd'
import finder, { SELECTOR } from './finder'
import { isElement, isParalelTransmission, isRedundantTransmission, isSerialTransmission } from './validator'

/**
 * Returns the diagram node key that represents the output end of a transmission chain.
 * - Element → element sequence
 * - Redundant → connector key (same as transmission sequence)
 * - Serial → output of last child (recursive)
 */
export function getTransmissionEndKey(item: IRBDItem): number {
    if (isElement(item)) {
        return item.sequence
    }

    if (isRedundantTransmission(item)) {
        return item.sequence
    }

    const elements = finder(item, SELECTOR.TRANSMISSION_ELEMENTS)

    if (!Array.isArray(elements) || elements.length === 0) {
        return item.sequence
    }

    return getTransmissionEndKey(elements[elements.length - 1])
}
